"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePresentingSession = void 0;
const validation_1 = require("@fmtk/validation");
exports.validatePresentingSession = (0, validation_1.properties)({
    id: (0, validation_1.text)(),
    name: (0, validation_1.text)(),
    accountId: (0, validation_1.text)(),
    created: (0, validation_1.integer)(),
    lastActivity: (0, validation_1.integer)(),
    connectionId: (0, validation_1.optional)((0, validation_1.text)()),
    presentationId: (0, validation_1.optional)((0, validation_1.text)()),
    presentationTitle: (0, validation_1.optional)((0, validation_1.text)()),
    presentationType: (0, validation_1.optional)((0, validation_1.text)()),
    presentationStatus: (0, validation_1.optional)((0, validation_1.text)()),
    OS: (0, validation_1.optional)((0, validation_1.text)()),
});
//# sourceMappingURL=PresentingSession.js.map